// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  GOOGLE_MAP_API_KEY: "AIzaSyAAq-N-XZCpwYYEEaHDF7tCWEdDSDZtg2M",
  PUBLIC_KEY: "pk_test_51L0rPMGUlBGybeRPaOihAR4XRTQ1eW3WNpgJ9hT6dOqSdXBR122t5aKdoPvUedhcBJKtMeMQkZv9Gm9E5wI2n2rA00UGMYmRE4", // test ridwan
  SECRET_KEY: "sk_test_51L0rPMGUlBGybeRPBIon5kYrWGoFW757cuqz70oXcmAJwsdUSOk8Im1CyWWamsBznWTLoCxBTFdK4JfTrbDcMMJI00gPJd6XcF", // test ridwan

  config : {
  API: 'https://devoretapi.co.uk/api/v1/website/', //live
  API2: 'https://devoretapi.co.uk/api/v1/', //live
  API3: 'https://urban-eatery.co.uk/api/', //live
  POSTCODE_URL: 'https://services.postcodeanywhere.co.uk/Capture/Interactive/', //test
  SERVICE_KEY: '',
  YOUR_SITE_KEY: '6LeoKfYUAAAAAId21NioS_8F-POKWr8XHXljdY6F',
  YOUR_SECRET_KEY: '6LeoKfYUAAAAAIfMnfhUC9cMQKb7aZKshA_lHV8E',
  Google_OAuth_Client_Id: '188035853745-jt0eqi1ng0fhjfst507vooitcamcgvfc.apps.googleusercontent.com',
  Facebook_App_Id: '889782398193217',

  STRIPE: 'urban-eatery',

  social_login: {
    is_active: false,
    facebook: {
      is_active: true
    },
    google: {
      is_active: true
    }
  },
  guest_login: true,


  //RESTAURANT_ID: '61b6fa7db0f0f8e3bc44c7d9', // Test Restaurant
  // RESTAURANT_ID: '5da70294fb57190da0fbf8ee', // o-play
  // RESTAURANT_ID: '5cb56f4155fa51463d9ff583', // EVEREST BRASSERIE
  // RESTAURANT_ID: '5c8f8238946618050834b27f', // The Rajasthan
  // RESTAURANT_ID: '5c57052fa2e01d10167edb6a', // Rajdoot
  // RESTAURANT_ID: '5cda73c010bff011fce384d2', // Little India Bexhill
  // RESTAURANT_ID: '5ef875f6fd42e602de6caeb7', // kushboo
  // RESTAURANT_ID: '5d2c52f1aabff20431fa0a36', // Sushi World
  RESTAURANT_ID: '5f300ba43ce80c68060bc1e8',

  RESTAURANT_NAME: 'Universal Restaurant App2',
  RES_LOCATION: 'GB', // for united kingdom: GB, Bangladesh: BD
  RES_BUILD_VERSION: 'live', // for production build: test = dist/app-v9/browser, live = browser
  RES_LIVE_PORT: 9002
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
